import { render, staticRenderFns } from "./FormQuestionsPage.vue?vue&type=template&id=9f1a73f2"
import script from "./FormQuestionsPage.vue?vue&type=script&lang=js"
export * from "./FormQuestionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports